<template>
  <form @submit.prevent="vLaunchDeliveryFormDetailsResearch">
    <div class="delivery-form-details-research">
      <div class="form-field">
        <label>{{$_('satab_product_reference')}}</label>
        <Select 
          :placeholder="$_('model')" 
          :itemoption="['TMOD', 'TMOD']"
          @select-change="vSelectedStore('delivery_details_tmod', $event.item)"
          :search="true"
          :data="product"
        />   
      </div>
      <div class="form-field">
        <label>{{$_('color')}}</label>
        <Select 
          :placeholder="$_('color')" 
          :itemoption="['TCOL', 'TCOL']"
          @select-change="vSelectedStore('delivery_details_tcol', $event.item)"
          :search="true"
          :data="color"
        />   
      </div>
      <div class="form-field">
        <label>Taille</label>
        <Select 
          :placeholder="$_('size')" 
          :itemoption="['TTAILLE', 'TTAILLE']"
          @select-change="vSelectedStore('delivery_details_ttaille', $event.item)"
          :search="true"
          :data="size"
        />   
      </div>
      <div class="form-field">
        <label>{{$_('customer_product_reference')}}</label>
        <Select 
          :placeholder="$_('customer_reference')" 
          :itemoption="['TREFC', 'TREFC']"
          @select-change="vSelectedStore('delivery_details_trefc', $event.item)"
          :search="true"
          :data="reference"
        />   
      </div>
      <div class="form-field">
        <button class="btn">{{$_('research_button')}}</button>
      </div>
    </div>
  </form>
</template>

<script>

import deliveryService from '@/modules/facture/services/deliveryService';

import Select from "@/common/components/widget/Select";

export default {
  name: 'DeliveryFormResearch',
  data() {
    return {
      product: Array(),
      color: Array(),
      size: Array(),
      reference: Array(),
    }
  },
  components: {
    Select
  },
  created() {

    this.$store.dispatch('facture/RESET_DELIVERY_DETAILS_RESEARCH');

    this.vGetDataInfo();
  },
  methods: {
    vLaunchDeliveryFormDetailsResearch() {
      this.$store.dispatch('facture/LAUNCH_DELIVERY_DETAILS_RESEARCH', {launch_delivery_details_research: true});
    },
    vSelectedStore(key, value) {
      this.$store.dispatch('facture/SELECT', {key, value});
    },
    vGetDataInfo() {

      let pnbl = this.$route.params.delivery_form_id

      // Référence modèle
      deliveryService.getProduct(pnbl)
      .then(res => {
        if(res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map(obj => {
            this.product.push(obj)
          });
        }
      }).catch(err => {
        console.error(err);
      });

      // Couleurs
      deliveryService.getColor(pnbl)
      .then(res => {
        if(res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map(obj => {
            this.color.push(obj)
          });
        }
      }).catch(err => {
        console.error(err);
      });

      // Taille
      deliveryService.getSize(pnbl)
      .then(res => {
        if(res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map(obj => {
            this.size.push(obj)
          });
        }
      }).catch(err => {
        console.error(err);
      });

      // référence client
      deliveryService.getReference(pnbl)
      .then(res => {
        if(res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map(obj => {
            this.reference.push(obj)
          });
        }
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
.delivery-form-details-research {
  background-color: #f5f5f5;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}
.form-field {
  margin: 5px;
}
label {
  padding-left: 20px;
}
/deep/ 
.select-box {
  margin: 0px;  
}
</style>